import React, { useRef } from "react";
import { Select, Tooltip } from "antd";
import { useSlateStatic, ReactEditor } from "slate-react";
import { Transforms, Text, Range } from "slate";

const fontSizeOptions = [
  '8', '9', '10', '11', '12', '13', '14', '16', '18',
  '20', '24', '30', '36', '48', '60', '72', '96'
];

export const FontSizeSelector = ({ disabled }) => {
  const editor = useSlateStatic();
  const savedSelection = useRef(null);

  const handleDropdownVisibleChange = (open) => {
    if (open && editor.selection && Range.isExpanded(editor.selection)) {
      savedSelection.current = editor.selection;
    }
  };

  const handleChange = (size) => {
    if (savedSelection.current) {
      ReactEditor.focus(editor);
      Transforms.select(editor, savedSelection.current);
    }
    Transforms.setNodes(
      editor,
      { fontSize: size },
      {
        match: Text.isText,
        split: true
      }
    );
  };

  return (
    <Tooltip title="Font Size" placement="bottom">
      <Select
        style={{ width: 70 }}
        placeholder="13"
        showSearch
        disabled={disabled}
        onChange={handleChange}
        onDropdownVisibleChange={handleDropdownVisibleChange}
        allowClear
      >
        {fontSizeOptions.map(size => (
          <Select.Option key={size} value={size}>
            {size}
          </Select.Option>
        ))}
      </Select>
    </Tooltip>
  );
};
